import React, { useState, useCallback, useEffect } from 'react'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import QuickLinkService from '../../services/quick-link.service'
import Loading from 'custom/assets/loaders/Loading'
import { RECEIPTS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import PaymentReceipts from './paymentsReceipts'
import TransferReceipts from './transferReceipts'
import { Formik, Form } from 'formik'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import validationConfig from 'custom/config/validation.config.json'
import { ReceiptSchema } from '../../schemas/downloadCenter'
import moment from 'moment'
import Pagination from 'react-js-pagination'
const downloadReceipConfig = validationConfig['downloadCenter']['receipt']

export default function Receipts() {
  const [loading, setLoading] = useState(false)
  const [noRecords, setNoRecords] = useState(false)
  const { t } = useTranslation()
  const [receiptsList, setReceiptsList] = useState([])
  const [receiptsDetails, setReceiptsDetails] = useState([])
  const [moduleType, setModuleType] = useState('FUNDTRANSFER')
  const [currentPage, setCurrentPage] = useState(1)
  const [currentPayment, setCurrentPayment] = useState(1)
  const pageLimit = 10
  const [totalRecords, setTotalRecords] = useState(10)
  const [formValues, setFormValues] = useState({
    fromDate: '',
    toDate: '',
  })

  useEffect(() => {
    moduleType === 'FUNDTRANSFER'
      ? lastNTransaction(0, {}, 'FUNDTRANSFER')
      : lastNTransaction(0, {}, 'BILLPAYMENT')
  }, [])

  const lastNTransaction = useCallback(async (page, values, module) => {
    try {
      setLoading(true)
      setReceiptsList([])
      setReceiptsDetails([])
      let reqParam = {
        module: module,
        fromDate: values?.fromDate || '',
        toDate: values?.toDate || '',
        page: page,
        size: pageLimit,
      }
      const response = await QuickLinkService.LastNTransactions(reqParam)
      if (response.status === 200) {
        setNoRecords(response.data['receipts'].length === 0 ? true : false)
        setReceiptsList(response.data['receipts'])
        setReceiptsDetails(response.data['receipts'])
        setTotalRecords(response.data['totalItems'])
      }
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }, [])

  const paginationChange = useCallback(async (page) => {
    setCurrentPage(page)
    lastNTransaction(page - 1, formValues, 'FUNDTRANSFER')
  }, [])

  const paginationPaymentChange = useCallback(async (paymentPage) => {
    setCurrentPayment(paymentPage)
    await lastNTransaction(paymentPage - 1, formValues, 'BILLPAYMENT')
  }, [])

  const onSearch = useCallback(async (values) => {
    if (values) {
      setFormValues({
        fromDate: values?.fromDate,
        toDate: values?.toDate,
      })
    }
    moduleType === 'FUNDTRANSFER'
      ? await lastNTransaction(0, values, 'FUNDTRANSFER')
      : await lastNTransaction(0, values, 'BILLPAYMENT')
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='RECEIPTS' showEmptySpace={true} keyPath={'RECEIPTS'}>
      <div className='mb-4'>
        <Formik initialValues={formValues} validationSchema={ReceiptSchema} onSubmit={onSearch}>
          {({ isSubmitting, errors, touched, handleChange, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-4 p-0 mx-3'>
                  <NeoInput
                    showAsterisk={downloadReceipConfig['isFromDateRequired']}
                    text={t(RECEIPTS_KEYS.FORM_DATE)}
                    name='fromDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                  <InputError text={errors.fromDate} touched={touched.fromDate} />
                </div>
                <div className='form-group col-4 p-0 mx-3'>
                  <NeoInput
                    showAsterisk={downloadReceipConfig['isToDateRequired']}
                    text={t(RECEIPTS_KEYS.TO_DATE)}
                    name='toDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                  />
                  <InputError text={errors.toDate} touched={touched.toDate} />
                </div>
                <div className='col-2 p-0' style={{ marginTop: '30px' }}>
                  <NeoButton type='submit' text={t(RECEIPTS_KEYS.SEARCH)} mode='newDesign' />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className='receipt-section'>
        <div className='row tab-navbar'>
          <div className={moduleType === 'FUNDTRANSFER' ? 'col-6 selected' : 'col-6'}>
            <span
              onClick={() => {
                setModuleType('FUNDTRANSFER')
                lastNTransaction(0, formValues, 'FUNDTRANSFER')
                setCurrentPage(1)
              }}>
              {t(RECEIPTS_KEYS.TRANSFERS)}
            </span>
          </div>
          <div className={moduleType === 'BILLPAYMENT' ? 'col-6 selected' : 'col-6'}>
            <span
              onClick={() => {
                setModuleType('BILLPAYMENT')
                lastNTransaction(0, formValues, 'BILLPAYMENT')
                setCurrentPayment(1)
              }}>
              {t(RECEIPTS_KEYS.PAYMENTS)}
            </span>
          </div>
        </div>

        {loading && renderLoading()}

        {noRecords && <div className='no-data-found'>{t(RECEIPTS_KEYS.NORECEIPTS)} </div>}

        {moduleType === 'FUNDTRANSFER' && receiptsList.length > 0 && (
          <TransferReceipts dataSource={receiptsList} />
        )}
        {moduleType === 'BILLPAYMENT' && receiptsDetails.length > 0 && (
          <PaymentReceipts dataSource={receiptsDetails} />
        )}
      </div>
      <div className='d-flex justify-content-center mb-5 mt-2'>
        {moduleType === 'FUNDTRANSFER'
          ? !loading &&
            receiptsList?.length > 0 && (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={pageLimit}
                totalItemsCount={totalRecords}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={paginationChange}
              />
            )
          : !loading &&
            receiptsDetails.length > 0 && (
              <Pagination
                activePage={currentPayment}
                itemsCountPerPage={pageLimit}
                totalItemsCount={totalRecords}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={paginationPaymentChange}
              />
            )}
      </div>
    </LayoutWithOutAccountCard>
  )
}
